// The global homepage's own URL path for CMS resolution/targeting. The homepage is the site
// root, so it resolves the standalone page published at '/'.
//
// Shared between the client renderer (home-cms-content) and the server-side prefetch
// (get-home-server-side-props) so both issue the CMS resolve with the *same* urlPath — the
// prefetched Apollo cache entry only satisfies the client's cache-first query when the variables
// match exactly. See ECOMM-11826.
export const HOME_URL_PATH = '/';
